$(function(){
  function slickSlider() {
    $('.c-part-detail-images .slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.c-part-detail-images .slider-nav'
    });
    $('.c-part-detail-images .slider-nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.c-part-detail-images .slider-for',
      dots: false,
      arrows: false,
      centerMode: false,
      focusOnSelect: true
    });
  }
  
  function checkEmptyInput(){
    
    $('.grouped-button input[type=submit]').addClass('is-disable').prop("disabled", true).css('cursor','not-allowed');
    
  	var c_bundle__quantity = $('.c-bundle__quantity input[name=group_quantity]');
    
    c_bundle__quantity.on('input',function() {

      var sum=0;

      c_bundle__quantity.each(function () {
        sum += +$(this).val();
      });
      
      if(sum>0) {
        $('.grouped-button input[type=submit]').removeClass('is-disable').removeAttr("disabled").css('cursor','default');
      } else {
        $('.grouped-button input[type=submit]').addClass('is-disable').prop("disabled", true).css('cursor','not-allowed');
      }
    });
    
//     var c_bundle__inventory_quantity = $('.c-bundle__quantity').attr('data-inventory');
    
//     if (c_bundle__inventory_quantity > 0){
//       var c_bundle__quantity = $('.c-bundle__quantity input[name=group_quantity]');

//       c_bundle__quantity.on('input',function() {

//         var sum=0;

//         c_bundle__quantity.each(function () {
//           sum += +$(this).val();
//         });

//         if(sum>0) {
//           $('.grouped-button input[type=submit]').removeClass('is-disable').removeAttr("disabled");
//         } else {
//           $('.grouped-button input[type=submit]').addClass('is-disable').prop("disabled", true);
//         }
//       });
//     } else {
//     	$('.c-bundle__quantity').html('<span>在庫切れ</span>');
//     }
  }

  function bundleAddToCart(){

    var bundleAddToCartBtn = '[data-bundle-add-to-cart-btn]';

    $(document).off('click.BundleAddToCart', bundleAddToCartBtn).on('click.BundleAddToCart', bundleAddToCartBtn, function (e) {
      
      e.preventDefault();
      e.stopPropagation();

      var self = $(this);
      var formData = $(self.data('form-id'));
      var data = formData.serialize();
      
      var partDetailContent = $('.c-part-detail-content'),
          partDetailVariant = partDetailContent.find('.c-bundle-content__item');

      var form = partDetailContent.find('form[action="/cart/add"]');

      Shopify.queue = [];

      partDetailVariant.each(function(){
        var variantID = $(this).attr('data-variant-id'),
            quantity = parseInt($(this).find('input[name=group_quantity]').val());

        if(quantity > 0 && variantID !== '') {
          Shopify.queue.push( {
            variantId: variantID,
            quantity: parseInt(quantity, 10) || 0
          });
        }
      });

      Shopify.moveAlong = function() {
        if (Shopify.queue.length) {
          var request = Shopify.queue.shift();

          Shopify.addItem(request.variantId, request.quantity, Shopify.moveAlong);
        }
        else {
          document.location.href = '/cart';
        }
      };
      
      Shopify.moveAlong();
    });
  }
  
  function categoryBlankImage(){
	var blankImage = $('.c-category-bottom__list_img');

    blankImage.each(function(){
      var getBlankImage = $(this).find('img');
      
      if (!getBlankImage){
      	$(this).find('img').addClass('is-none');
        $(this).find('span').removeClass('is-none');
      }
    });
  }
  
  function categoryScrollDown(){

    $('[data-scroll-down]').click(function() {
      var self = $(this);
      var num = self.data('scroll-down'),
          num_handle = $('#'+num);
      
      var offset,
          windowHeight = $(window).height(),
          targetOffset = num_handle.offset().top,
          targetHeight = num_handle.height();
      
      if (targetHeight < windowHeight) {
        offset = targetOffset - $("#section-header").height();
      }
      else {
        offset = targetOffset;
      }

      $('html, body').animate({
        scrollTop: offset
      }, 500);
    });
  }
  
  function checkStopProduction(){
  	var checkStopProduction = $('.c-custom-search-bar__sub-description');
//     var stopProductionInput = ('<input class="c-stop-production-type-name" type="hidden" name="filter.p.m.info.status" value="生産終了"/>');
    
    checkStopProduction.off('click.StopProduction').on('click.StopProduction', function () {
      $(this).toggleClass('is-check');
      
      if ($(this).hasClass('is-check')) {
        $('.Search__Form input[name=type]').attr('value','stop_production');
//         $('.Search__Form').append(stopProductionInput);
      } else {
        $('.Search__Form input[name=type]').attr('value','product');
//         $('.Search__Form .c-stop-production-type-name').remove();
      }
    });
    
    var current_url = window.location.href;

    if (current_url.indexOf('type=product') != -1){
      
      $('.Search__Form input[name=type]').attr('value','product');
//       $('.Search__Form .c-stop-production-type-name').remove();

      checkStopProduction.removeClass('is-check');
      
    } else if (current_url.indexOf('type=stop_production') != -1) {
      
      $('.Search__Form input[name=type]').attr('value','stop_production');
//       $('.Search__Form').append(stopProductionInput);
      
      checkStopProduction.addClass('is-check');
    }
  }
  
  function appendDelivery() {
    if($('.Cart__Recap').length > 0){
      var checkDeliveryTime = setInterval(function() {
        var $item = $('#cart-delivery-datetime_section_os2 .delivery-container');
        if ($item.length) {
          
          clearInterval(checkDeliveryTime);
          
          setTimeout(function(){
            $('.Cart__ShippingBox').append($('#cart-delivery-datetime_section_os2').parent());
          }, 500);
          
          setTimeout(function(){            
            $('.delivery-radio-container__label-box').each(function(){
              var self = $(this),
                  findInput = self.find('.delivery-radio-container__input'),
                  findSpan = self.find('span');
              
              findSpan.attr('data-input', findInput.val());
              
              if (findInput.val() == '日付を指定しない'){
                self.append('<input id="delivery-text" type="hidden" name="attributes[配送希望日]" value="指定なし">');
              }
              
              findSpan.click(function(){
                if($(this).attr('data-input') == '日付を指定しない'){
                  $('#delivery-text').attr('name', 'attributes[配送希望日]');
                } else {
                  $('#delivery-text').removeAttr('name');
                }
              })
            });
          },2000);
        }
      },100);
      
      var checkDeliveryTime2 = setInterval(function() {
        var $render = $('#cart-delivery-datetime_section #delivery-datetime--isRender');
        if ($render.length) {
          clearInterval(checkDeliveryTime2);
          
          var deliveryTitle = $render.find('.delivery-title');
          
          deliveryTitle.each(function(){
            if($(this).text() == 'お届け希望日の指定'){
              $(this).css('margin-top','0');
              $(this).after('<p class="delivery-title-2">※指定がない場合、翌または翌々営業日に出荷します。<br>お急ぎの場合、着日指定はせずにご注文ください。</p>')
            } else if($(this).text() == 'お届け希望時間の指定'){
              $(this).css('margin-top','20px');
            }
          });
          
          setTimeout(function(){
            $('.delivery-select-container.amp-select-allow').first().after('<p class="delivery-title-3">※土日祝日、全地域含め配達可能な最短指定日のため、<br>10日後からのご指定となります。</p>');
            $('.delivery-select-container.amp-select-allow').last().after('<p class="delivery-title-3 delivery-title-32">最短発送をご希望の場合は、着指定なしでご注文をお願い致します</p>');
          },2000)
        }
      })
    }
  }

  if ($('body').hasClass('template-product')){
    slickSlider();
    checkEmptyInput();
    bundleAddToCart();
  } else if ($('body').hasClass('template-page')){
    categoryScrollDown();
    categoryBlankImage();
  } else if ($('body').hasClass('template-cart')){
  	appendDelivery();
  }
  checkStopProduction();
})

$(document).ready(function() {	
  var productCount = $('.template-collection .CollectionInner__Products .Grid__Cell').length;	
  if (productCount === 1) {	
    var productLink = $('.template-collection .CollectionInner__Products .Grid__Cell a.ProductItem__ImageWrapper').attr('href');	
    window.location.href = productLink;	
  }	
});